export const state = {
  
    isFillRoutes: false,
    language:localStorage.getItem('language') || 'tr',
  };
  
  export const getters = {
 
    getLanguage(state){
       return state.language;
    }
  };
  export const mutations = {
      setIsFillRoutes(state, payload) {
        state.isFillRoutes = payload;
      },
      resetIsFillRoutes(state) {
        state.isFillRoutes = false;
      },
      setLanguageMut(state,payload){
        state.language = payload;
        localStorage.setItem('language', payload);
      }
  };

  export const actions = {

     setLanguageAction({ commit } , { lang }) {
      commit('setLanguageMut',lang);
  
    },   
  };
  